import React from 'react';

import TenantAddButton from '@totem/components/tenants/tenantsPage/TenantAddButton';
import TenantsContainer from '@totem/components/tenants/tenantsPage/TenantsContainer';
import TenantsTable from '@totem/components/tenants/tenantsPage/TenantsTable';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const TenantsPage = () => {
  return (
    <TenantsContainer>
      <ContentLayout contentRight={<TenantAddButton />}>
        <IBCard isCovered>
          <TenantsTable />
        </IBCard>
      </ContentLayout>
    </TenantsContainer>
  );
};

export default TenantsPage;
